import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Skeleton from "@mui/material/Skeleton";
import { useInView } from "react-intersection-observer";
import { useYoutubeEmbedReady } from "../../hooks/useYoutubeEmbedReady";
import { INPUT_COLOR_BORDER } from "../../utils/colors";

export const YOUTUBE_EMBED_PREVIEW_BORDER_RADIUS = 3;

const YoutubeEmbedPreview = ({
  youtubeVideoId = null,
  height = 210,
  width = 250,
  sx = {},
}) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    rootMargin: "300px 0px",
  });

  const hasVideoId = Boolean(youtubeVideoId);
  const { isEmbedReady } = useYoutubeEmbedReady({ youtubeVideoId });
  const isWaitingForEmbed = hasVideoId && inView && !isEmbedReady;
  const shouldShowEmbed = hasVideoId && inView && isEmbedReady;

  return (
    <Box
      ref={ref}
      sx={{
        height,
        width: { xs: "100%", sm: width },
        maxWidth: "100%",
        flexShrink: 0,
        borderRadius: YOUTUBE_EMBED_PREVIEW_BORDER_RADIUS,
        overflow: "hidden",
        ...(isWaitingForEmbed
          ? {
              border: `1px solid ${INPUT_COLOR_BORDER}`,
              bgcolor: "fields.background",
            }
          : {}),
        ...sx,
      }}
    >
      {shouldShowEmbed ? (
        <Box
          component="iframe"
          src={`https://www.youtube.com/embed/${youtubeVideoId}`}
          title={youtubeVideoId}
          sx={{
            width: "100%",
            height: "100%",
            border: 0,
            display: "block",
          }}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        />
      ) : isWaitingForEmbed ? (
        <Box
          sx={{
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            bgcolor: "fields.background",
          }}
        >
          <CircularProgress size={32} />
        </Box>
      ) : (
        <Skeleton
          variant="rectangular"
          width="100%"
          height="100%"
          sx={{
            borderRadius: YOUTUBE_EMBED_PREVIEW_BORDER_RADIUS,
            bgcolor: hasVideoId ? "action.hover" : "action.disabledBackground",
          }}
        />
      )}
    </Box>
  );
};

export default YoutubeEmbedPreview;